import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectorRef,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { AlertService, PastEventService, AppService } from "../_services/index";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { appConfig } from "../app.config";
import { ToastrService } from "ngx-toastr";
import { DynamicGrid } from "src/app/_services/grid.modal";
import { ImageCroppedEvent } from "ngx-image-cropper";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { DataTableDirective } from "angular-datatables";

class Event {
  id: number = 0;
  name: string = "";
  about: string = "";
  from_date: string = "";
  to_date: string = "";
  event_type: string = "";
  event_address: string = "";
  event_state: number = 0;
  event_city: number = 0;
  sectorofenterprise: string = "";
  areaofinterest: string = "";
  areaofstudy: string = "";
  event_category: string = "";
  event_vertical: string = "";
  oraganised_by: string = "";
  event_language: string = "";
  who_is_relevant_for: string = "";
  associate_partners: string = "";
  registration_details_link: string = "";
  keywords: string = "";
  eventinput: Array<DynamicGrid> = [];
  home_display: string = "";
  is_active: string = "";
}

@Component({
  selector: "app-past-event",
  templateUrl: "./past-event.component.html",
  styleUrls: ["./past.event.component.css"],
})
export class PastEventComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [
      { orderable: false, targets: 8 },
      {
        targets: 6,
        render: (data: any, type: string, row: any) => {
          if (type === "sort" || type === "type") {
            return new Date(data).getTime();
          }
          return data;
        },
      },
    ],
  };

  @Input() allowMultiple: boolean = false;
  @Input() allowMultipleImage: boolean = true;
  @Input() allowMultipleVideo: boolean = true;
  @Input() fileType: string = ".jpg , .png , .bmp";
  @Input() fileTypeImage: string = ".jpg , .png , .bmp";
  @Input() fileTypeVideo: string = ".mp4 , .ogg, .webm";
  @Input() required: boolean = false;
  @Input() maxSizeInKb: number = 0;
  @Output() onSelection = new EventEmitter<FileList>();

  DisplayedText: string = "";
  fileList: any;
  fileListImage: any;
  private selectedFiles = new Set<string>();
  urlThumbError: any = "";
  maxUrls = 10;

  fileListVideo: any;
  pdf = false;
  exl = false;
  dtTrigger = new Subject<any>();
  eventList: Event[] = [];
  isSubmitted = false;
  videoError: any = "";

  event_id: any;
  apiUrl: any;
  error: any = { isError: false, errorMessage: "" };
  event_owner: any = "wep";

  getEvent = {
    id: "",
    name: "",
    about: "",
    from_date: "",
    to_date: "",
    image: "",
    event_type: "",
    event_address: "",
    event_state: "",
    event_city: "",
    sectorofenterprise: "",
    areaofinterest: "",
    areaofstudy: "",
    event_category: "",
    event_vertical: "",
    oraganised_by: "",
    event_language: "",
    who_is_relevant_for: "",
    associate_partners: "",
    registration_details_link: "",
    keywords: "",
    eventinput: [],
    home_display: "",
    is_active: "",
  };

  closeResult: string = "";
  dynamicArray: Array<DynamicGrid> = [];
  newDynamic: any = {};
  formError: any = "";
  imageError: any = "";
  selectedToEnterprise: any;
  myStringEnterprise: any;
  myArrayEnterprise: any;

  selectedToInterest: any;
  myStringInterest: any;
  myArrayInterest: any;

  selectedToStudy: any;
  myStringStudy: any;
  myArrayStudy: any;

  selectedToPartners: any;
  myStringPartners: any;
  myArrayPartners: any;

  imageChangedEvent: any = "";
  croppedImage: any = "";
  image_cropper: any = "";

  configbody: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "15rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    toolbarHiddenButtons: [["bold"]],
    customClasses: [
      { name: "quote", class: "quote" },
      { name: "redText", class: "redText" },
      { name: "titleText", class: "titleText", tag: "h1" },
    ],
  };

  eventMediaListVideo: any = [];

  base64Images: any = [];
  previewImages: any = [];
  eventMediaListImage: any[] = [];
  previewVideos: Array<{ id: string; video: string; thumbnail: string }> = [];
  event_videos: Array<{ id: string; video: string; thumbnail: string }> = [];
  event_urls: Array<{ id: any; url: any }> = [{ id: "", url: "" }];

  modalReference!: NgbActiveModal;
  modalCropper!: NgbActiveModal;
  modalTitle: string = "";

  cat: any = {};
  states: any = {};
  cities: any = {};
  sectorofenterprise: any[] = [];
  areaofinterest: any = {};
  areaofstudy: any = {};
  associatepartners: any = {};
  showloding = true;
  lodingImage = false;

  event = {
    id: "",
    name: "",
    about: "",
    from_date: "",
    to_date: "",
    image: "",
    event_type: "",
    event_address: "",
    event_state: "",
    event_city: "",
    sectorofenterprise: "",
    areaofinterest: "",
    areaofstudy: "",
    event_vertical: "",
    oraganised_by: "",
    event_language: "",
    who_is_relevant_for: "",
    associate_partners: "",
    registration_details_link: "",
    keywords: "",
    eventinput: [],
    home_display: "",
    is_active: "",
    event_category: "",
  };

  constructor(
    public router: Router,
    private dataService: PastEventService,
    private alertService: AlertService,
    private AppService: AppService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    window.scroll(0, 0);

    this.apiUrl = appConfig.apiUrl + "/";

    this.allEvent();

    this.dataService.getAllState().subscribe((data) => {
      this.states = data["state"];
    });

    this.dataService.getAllCity().subscribe((data) => {
      this.cities = data["state"];
    });

    this.dataService.getEventCategory().subscribe((data) => {
      this.cat = data["cat"];
    });

    this.dataService.getSectorofEnterprise().subscribe((data) => {
      this.sectorofenterprise = data["sectorofenterprise"];
      if (Array.isArray(this.sectorofenterprise)) {
        this.sectorofenterprise.unshift({ id: "all", name: "Select All" });
      }
    });

    this.dataService.getAreaofInterest().subscribe((data) => {
      this.areaofinterest = data["areaofinterest"];
      if (Array.isArray(this.areaofinterest)) {
        this.areaofinterest.unshift({ id: "all", name: "Select All" });
      }
    });

    this.dataService.getAreaofStudy().subscribe((data) => {
      this.areaofstudy = data["area_of_study"];
      if (Array.isArray(this.areaofstudy)) {
        this.areaofstudy.unshift({ id: "all", name: "Select All" });
      }
    });

    this.dataService.getAssociatePartners().subscribe((data) => {
      this.associatepartners = data["partner"];
    });
  }

  onClickEventChange() {
    this.event_owner = this.event_owner === "wep" ? "other" : "wep";
  }

  compareTwoDates() {
    if (new Date(this.getEvent.from_date) < new Date(this.getEvent.to_date)) {
      this.error = {
        isError: true,
        errorMessage: "End Date can not before start date",
      };
    }
  }

  removeEventMedia(id: any, type: any) {
    let itemName = "";
    switch (type) {
      case "image":
        itemName = "image";
        break;
      case "video":
        itemName = "video";
        break;
      case "url":
        itemName = "URL";
        break;
      default:
        itemName = "item";
        break;
    }

    if (!confirm(`Do you really want to delete this ${itemName}?`)) return;

    if (type === "image") {
      this.eventMediaListImage = this.eventMediaListImage.filter(
        (img) => img.id !== id
      );
    } else if (type === "video") {
      this.event_videos = this.event_videos.filter((vid) => vid.id !== id);
    } else if (type === "url") {
      this.event_urls = this.event_urls.filter((urlObj) => urlObj.id !== id);
      if (this.event_urls.length === 0) {
        this.event_urls = [{ id: "", url: "" }];
      }
    }

    const data = { id: id, type: type };
    this.loadShow();

    this.dataService.eventMediaDelete(data).subscribe({
      next: (res) => {
        if (res["status"] == 200) {
          this.toastr.success(`${itemName} deleted successfully`);
        } else {
          this.toastr.error("Delete failed on server");
        }
        this.loadHide();
      },
      error: (err) => {
        this.toastr.error("Error: " + err.message);
        this.getAllMedia();
        this.loadHide();
      },
    });
  }

  fileChangeVideoThumbnail(event: any, index: number) {
    this.imageError = "";
    this.videoError = "";
    const files: FileList = event.target.files;
    const date = Date.now();

    if (!files || files.length === 0) return;

    const validExtensions = this.fileType
      .split(",")
      .map((ext) => ext.trim().toLowerCase());

    Array.from(files).forEach((file: File) => {
      const extension = "." + file.name.split(".").pop().toLowerCase();
      const fileKey = `${file.name}_${file.size}_${date}`;

      if (this.selectedFiles.has(fileKey)) return;
      this.selectedFiles.add(fileKey);

      if (!validExtensions.includes(extension)) {
        alert(
          `Invalid file type: ${extension}. Allowed types: ${this.fileType}`
        );
        return;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const base64Thumb: string = e.target.result;

        const fileReport = this.buildFileReport(file, base64Thumb);

        this.dataService.fileUploadCheck(fileReport).subscribe((res: any) => {
          if (res["status"] === 200) {
            this.previewVideos[index].thumbnail = base64Thumb;
          } else if (res["status"] === 422) {
            this.removeOrBlankThumbnail(index, file.name);
            this.videoThumbnailErr(res);
          }
        });
      };

      reader.readAsDataURL(file);
    });
    event.target.value = "";
  }

  private videoThumbnailErr(res: any) {
    if (res["errors"][0]) {
      this.videoError = `${res["errors"][0]["name"]} exceed the allowed size limit (Limit kb - ${res["errors"][0]["limit_kb"]})`;
      setTimeout(() => (this.videoError = ""), 5000);
    }
  }

  hasThumbnail(video: any): boolean {
    return !!video.thumbnail && video.thumbnail.trim() !== "";
  }

  addUrlField() {
    if (this.event_urls.length < this.maxUrls) {
      this.event_urls.push({ id: "", url: "" });
    } else {
      alert(`Maximum ${this.maxUrls} URLs allowed.`);
    }
  }

  removeUrlField(index: number) {
    const urlItem = this.event_urls[index];

    if (urlItem.id == "") {
      this.event_urls.splice(index, 1);
      return;
    }

    if (this.event_urls.length <= 1) return;

    if (confirm("Are you sure you want to delete this URL?")) {
      const data = { id: urlItem.id, type: "url" };
      this.loadShow();

      this.dataService.eventMediaDelete(data).subscribe({
        next: (res) => {
          if (res["status"] === 200) {
            this.event_urls.splice(index, 1);
          } else {
            this.alertService.error("Failed to delete URL");
          }
          this.loadHide();
        },
        error: (err) => {
          this.alertService.error("Error: " + err.message);
        },
      });
    }
  }

  private removeOrBlankThumbnail(index: number, fileName: string) {
    if (index >= this.previewVideos.length) return;
    this.previewVideos[index].thumbnail = "";
  }

  allEvent() {
    this.loadShow();
    var data = { type: "" };
    this.dataService.getAllEvent(data).subscribe((data) => {
      this.eventList = data["event"];

      this.pdf = true;
      this.exl = true;
      this.rerender();
      this.loadHide();
    });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  changeToEnterprise() {
    if (this.selectedToEnterprise.includes("all")) {
      this.selectedToEnterprise = (
        this.sectorofenterprise as { id: string; name: string }[]
      )
        .filter((sector) => sector.id !== "all")
        .map((sector) => sector.id);
    }
    this.event.sectorofenterprise = this.selectedToEnterprise;
  }

  changeToInterest() {
    if (this.selectedToInterest.includes("all")) {
      this.selectedToInterest = (
        this.areaofinterest as { id: string; name: string }[]
      )
        .filter((sector) => sector.id !== "all")
        .map((sector) => sector.id);
    }
    this.event.areaofinterest = this.selectedToInterest;
  }

  changeToStudy() {
    if (this.selectedToStudy.includes("all")) {
      this.selectedToStudy = (
        this.areaofstudy as { id: string; name: string }[]
      )
        .filter((sector) => sector.id !== "all")
        .map((sector) => sector.id);
    }
    this.event.areaofstudy = this.selectedToStudy;
  }

  changeToPartners() {
    this.event.associate_partners = this.selectedToPartners;
  }

  selectCityById(id: any) {
    this.dataService.getCityById(id).subscribe((data) => {
      this.cities = data["city"];
    });
  }

  open(content: any) {
    this.croppedImage = "";
    this.isSubmitted = false;
    this.selectedToPartners = "";
    this.selectedToStudy = "";
    this.selectedToInterest = "";
    this.selectedToEnterprise = "";
    this.event = {
      id: "",
      name: "",
      about: "",
      from_date: "",
      to_date: "",
      image: "",
      event_type: "",
      event_address: "",
      event_state: "",
      event_city: "",
      sectorofenterprise: "",
      areaofinterest: "",
      areaofstudy: "",
      event_vertical: "",
      oraganised_by: "",
      event_language: "",
      who_is_relevant_for: "",
      associate_partners: "",
      registration_details_link: "",
      keywords: "",
      eventinput: [],
      home_display: "N",
      is_active: "Y",
      event_category: "",
    };
    this.DisplayedText = "";
    this.modalTitle = "Add Event";
    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
  }

  save(val: any, f: any) {
    this.isSubmitted = true;

    if (
      this.isFieldsInvalid(this.event.name) ||
      this.isFieldsInvalid(this.event.oraganised_by) ||
      this.isFieldsInvalid(this.event.event_language)
    ) {
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (f.form.valid) {
      this.loadShow();
      this.insertAction(val, f);
    } else {
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  edit(id: any, content: any) {
    this.isSubmitted = true;
    this.loadShow();
    this.DisplayedText = "";

    this.dataService.getEvent(id).subscribe((data) => {
      this.getEvent = data["event"];

      if (this.getEvent.event_state != null) {
        this.selectCityById(this.getEvent.event_state);
      }

      this.myStringEnterprise = this.getEvent.sectorofenterprise;
      if (this.myStringEnterprise) {
        this.myArrayEnterprise = this.myStringEnterprise.split(",").map(Number);
        this.selectedToEnterprise = this.myArrayEnterprise;
      }

      this.myStringInterest = this.getEvent.areaofinterest;
      if (this.myStringInterest) {
        this.myArrayInterest = this.myStringInterest.split(",").map(Number);
        this.selectedToInterest = this.myArrayInterest;
      }

      this.myStringStudy = this.getEvent.areaofstudy;
      if (this.myStringStudy) {
        this.myArrayStudy = this.myStringStudy.split(",").map(Number);
        this.selectedToStudy = this.myArrayStudy;
      }

      this.myStringPartners = this.getEvent.associate_partners;
      if (this.myStringPartners) {
        this.myArrayPartners = this.myStringPartners.split(",").map(Number);
        this.selectedToPartners = this.myArrayPartners;
      }

      this.croppedImage = this.getEvent.image || "";

      Object.assign(this.event, this.getEvent);

      this.loadHide();
      this.isSubmitted = false;
      this.modalTitle = "Edit Event";
      this.modalReference = this.modalService.open(content, {
        backdrop: "static",
        keyboard: false,
      });
    });
  }

  upload(id: any, media: any) {
    this.event_id = id;
    this.modalTitle = "Upload Media";
    this.formError = "";
    this.previewImages = [];
    this.previewVideos = [];
    this.base64Images = [];

    this.event_urls = [{ id: "", url: "" }];

    this.modalReference = this.modalService.open(media, {
      backdrop: "static",
      keyboard: false,
    });
    this.getAllMedia();
  }

  getAllMedia() {
    this.loadShow();
    var data = { event_id: this.event_id };
    this.dataService.getEventMediaById(data).subscribe((res) => {
      const eventGallery = res["eventGallery"];
      this.eventMediaListImage = eventGallery.filter(
        (item: any) => item.type === "image"
      );

      this.event_videos = eventGallery
        .filter((item: any) => item.type === "video")
        .map((item: any) => ({
          id: item.id,
          video: item.image,
          thumbnail: item.image_thumbnail,
        }));

      const apiUrls = eventGallery
        .filter((item: any) => item.type === "url")
        .map((urlItem: any) => ({
          id: urlItem.id || "",
          url: urlItem.image || "",
          thumbnail: urlItem.image_thumbnail || "",
        }));

      this.event_urls = apiUrls.length > 0 ? apiUrls : [{ id: "", url: "" }];

      this.loadHide();
    });
  }

  insertAction(val: any, f: any) {
    let formData: FormData = new FormData();

    formData.append("name", this.event.name);
    formData.append("about", this.event.about);
    formData.append("from_date", this.event.from_date);
    formData.append("to_date", this.event.to_date);
    formData.append("event_type", this.event.event_type);
    formData.append("event_address", this.event.event_address);
    formData.append("event_state", this.event.event_state);
    formData.append("event_city", this.event.event_city);
    formData.append("event_owner", this.event_owner);

    if (this.selectedToEnterprise) {
      formData.append(
        "sectorofenterprise",
        this.selectedToEnterprise.join(",")
      );
    } else {
      formData.append("sectorofenterprise", "");
    }

    if (this.selectedToInterest) {
      formData.append("areaofinterest", this.selectedToInterest.join(","));
    } else {
      formData.append("areaofinterest", "");
    }

    if (this.selectedToStudy) {
      formData.append("areaofstudy", this.selectedToStudy.join(","));
    } else {
      formData.append("areaofstudy", "");
    }

    if (this.selectedToPartners) {
      formData.append("associate_partners", this.selectedToPartners.join(","));
    } else {
      formData.append("associate_partners", "");
    }

    formData.append("event_category", this.event.event_category);
    formData.append("event_vertical", this.event.event_vertical);
    formData.append("oraganised_by", this.event.oraganised_by);
    formData.append("event_language", this.event.event_language);
    formData.append("who_is_relevant_for", this.event.who_is_relevant_for);
    formData.append(
      "registration_details_link",
      this.event.registration_details_link
    );
    formData.append("keywords", this.event.keywords);
    formData.append("home_display", this.event.home_display);
    formData.append("is_active", this.event.is_active);

    if (val.id == "") {
      if (this.fileList && this.fileList.length > 0) {
        formData.append("image", this.croppedImage);
      } else {
        formData.append("image", "");
      }

      this.dataService.save(formData).subscribe(
        (data: any) => {
          if (data.status == 200) {
            this.croppedImage = "";
            this.allEvent();
            this.alertService.success("Event created successfully", true);
            this.modalReference.close();
          } else if (data.status == 422) {
            document
              .querySelector(".modal")
              .scrollTo({ top: 0, behavior: "smooth" });
            this.alertService.error(data.mesg);
            this.loadHide();
          }
        },
        (error) => {
          this.alertService.error(error);
          document
            .querySelector(".modal")
            .scrollTo({ top: 0, behavior: "smooth" });
        }
      );
    } else {
      formData.append("id", val.id);
      if (this.fileList !== undefined) {
        formData.append("image", this.croppedImage);
      }

      this.dataService.eventUpdate(formData).subscribe(
        (data: any) => {
          if (data["status"] == 200) {
            this.modalReference.close();
            this.allEvent();
            this.alertService.success("Event updated successfully", true);
          } else if (data["status"] == 422) {
            this.alertService.error(data.mesg);
            document
              .querySelector(".modal")
              .scrollTo({ top: 0, behavior: "smooth" });
            this.loadHide();
          }
        },
        (error) => {
          this.alertService.error(error);
          document
            .querySelector(".modal")
            .scrollTo({ top: 0, behavior: "smooth" });
        }
      );
    }
  }

  fileChangeVideo(event: any) {
    this.imageError = "";
    this.videoError = "";
    const files: FileList = event.target.files;
    const date = Date.now();

    if (!files || files.length === 0) return;
    if (!Array.isArray(this.previewVideos)) this.previewVideos = [];

    const validExtensions = this.fileTypeVideo
      .split(",")
      .map((ext) => ext.trim().toLowerCase());

    Array.from(files).forEach((file: File) => {
      const extension = "." + file.name.split(".").pop().toLowerCase();

      const fileKey = `${file.name}_${file.size}_${date}`;
      if (this.selectedFiles.has(fileKey)) return;
      this.selectedFiles.add(fileKey);

      if (!validExtensions.includes(extension)) {
        alert(
          `Invalid file type: ${extension}. Allowed: ${this.fileTypeVideo}`
        );
        return;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const base64String: string = e.target.result;
        const tempIndex = this.previewVideos.length;

        const fileReport = this.buildFileReportForVideo(file, base64String);

        this.dataService.fileUploadCheck(fileReport).subscribe((res: any) => {
          if (res && res["status"] === 200) {
            this.previewVideos.push({
              id: "",
              video: base64String,
              thumbnail: "",
            });
          } else if (res && res["status"] === 422) {
            this.removeOrBlankVideo(tempIndex, file.name);
            this.videoErr(res);
          }
        });
      };
      reader.readAsDataURL(file);
    });

    event.target.value = "";
  }

  private videoErr(res: any) {
    if (res["errors"][0]) {
      this.videoError = `${res["errors"][0]["name"]} exceed the allowed size limit (Limit kb - ${res["errors"][0]["limit_kb"]})`;
      setTimeout(() => (this.videoError = ""), 5000);
    }
  }

  private removeOrBlankVideo(index: number, fileName: string) {
    if (index >= this.previewVideos.length) return;
    this.previewVideos.splice(index, 1);
  }

  uploadUrlThumbnail(event: any, index: number) {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    const validExtensions = this.fileType
      .split(",")
      .map((ext) => ext.trim().toLowerCase());

    Array.from(files).forEach((file: File) => {
      const extension = "." + file.name.split(".").pop().toLowerCase();

      const fileKey = `${file.name}_${file.size}`;
      if (this.selectedFiles.has(fileKey)) return;
      this.selectedFiles.add(fileKey);

      if (!validExtensions.includes(extension)) {
        alert(
          `Invalid file type: ${extension}. Allowed types: ${this.fileType}`
        );
        return;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const base64Thumb: string = e.target.result;
        const fileReport = this.buildFileReport(file, base64Thumb);

        this.dataService.fileUploadCheck(fileReport).subscribe((res: any) => {
          if (res["status"] === 200) {
            // Thumbnail accepted
          } else if (res["status"] === 422) {
            this.removeUrlThumbnail(index, file.name);
            this.urlThumbnailErr(res);
          }
        });
      };
      reader.readAsDataURL(file);
    });
    event.target.value = "";
  }

  private urlThumbnailErr(res: any) {
    if (res["errors"][0]) {
      this.urlThumbError = `${res["errors"][0]["name"]} exceed the allowed size limit (Limit kb - ${res["errors"][0]["limit_kb"]})`;
      setTimeout(() => (this.urlThumbError = ""), 5000);
    }
  }

  private removeUrlThumbnail(index: number, fileName: string) {
    if (index >= this.event_urls.length) return;
  }

  buildFileReportForVideo(currentFile: File, base64String: string): any {
    const files: any[] = [];
    files.push({
      type: "video",
      size: Math.round(currentFile.size / 1024),
      name: currentFile.name,
      extension: currentFile.name.split(".").pop().toLowerCase() || "mp4",
    });

    this.previewVideos.forEach((item, idx) => {
      if (item.video === base64String) return;
      const tempFile = this.dataURLtoFile(item.video, "temp.mp4");
      const name =
        this.extractFileNameFromBase64(item.video) || `video_${idx + 1}.mp4`;

      files.push({
        type: "video",
        size: Math.round(tempFile.size / 1024),
        name,
        extension: name.split(".").pop().toLowerCase() || "mp4",
      });
    });

    this.base64Images.forEach((b64, idx) => {
      const tempFile = this.dataURLtoFile(b64, "temp.jpg");
      const name =
        this.extractFileNameFromBase64(b64) || `image_${idx + 1}.jpg`;

      files.push({
        type: "image",
        size: Math.round(tempFile.size / 1024),
        name,
        extension: name.split(".").pop().toLowerCase() || "jpg",
      });
    });

    return { files };
  }

  private dataURLtoFile(dataurl: string, filename: string): File {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  }

  private extractFileNameFromBase64(b64: string): string | null {
    const match = b64.match(/name=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  delete(item: any) {
    this.loadShow();
    this.dataService.eventDelete(item.id).subscribe(
      (data) => {
        if (data["status"] == 200) {
          this.alertService.success("Event deleted successfully", true);
          item.is_active = item.is_active === "Y" ? "N" : "Y";
          this.allEvent();
        } else {
          this.alertService.error("Event error");
        }
      },
      (error) => {
        this.alertService.error(error);
      }
    );
    this.loadHide();
  }

  onFileChange(event: any) {
    this.fileList = event.target.files;
    this.DisplayedText = this.fileList[0].name || "";

    let hasFile = this.fileList && this.fileList.length > 0;

    if (hasFile) {
      var extension = this.fileList[0].name.substring(
        this.fileList[0].name.lastIndexOf(".")
      );
      var validFileType = ".jpg , .jpeg, .png , .bmp";

      if (validFileType.toLowerCase().indexOf(extension) < 0) {
        alert(
          "Please select a valid file type. Supported file types are .jpg, .jpeg, .png, .bmp"
        );
        this.fileList = null;
        return false;
      }

      if (this.fileList[0].size > 5000000) {
        alert(`File size is more than 5 MB`);
        this.fileList = null;
        return false;
      }

      const reader = new FileReader();
      reader.readAsDataURL(this.fileList[0]);

      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;

        img.onload = () => {
          if (img.height > img.width) {
            alert(
              "Please select a banner image (width should be greater than height)."
            );
            this.fileList = null;
            this.DisplayedText = "";
            this.croppedImage = "";
            event.target.value = "";
            return;
          } else {
            this.croppedImage = reader.result as string;
            this.event.image = this.croppedImage;
          }
        };
      };
    }
    return false;
  }

  removePreviewVideo(index: number) {
    this.previewVideos.splice(index, 1);
    this.cdr.detectChanges();
  }

  removePreviewImage(index: number) {
    this.previewImages.splice(index, 1);
    this.base64Images.splice(index, 1);
  }

  addRow() {
    this.newDynamic = { event_type: "", event_label: "", is_mandatory: "" };
    this.dynamicArray.push(this.newDynamic);
    this.toastr.success("New row added successfully", "New Row");
    return true;
  }

  deleteRow(index: number) {
    if (this.dynamicArray.length == 1) {
      this.toastr.error(
        "Can't delete the row when there is only one row",
        "Warning"
      );
      return false;
    } else {
      this.dynamicArray.splice(index, 1);
      this.toastr.warning("Row deleted successfully", "Delete row");
      return true;
    }
  }

  pdfExport() {
    window.open(appConfig.apiUrl + "/api/blog-list-pdf", "_blank");
  }

  xlExport() {
    window.open(appConfig.apiUrl + "/api/blog-list-excel", "_blank");
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

  fileChangeEvent(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.event.image = file;
      this.croppedImage = "";
    }
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  imageLoaded() {}

  cropperReady() {}

  loadImageFailed() {}

  openCropper(contentCrop: any) {
    this.modalReference = this.modalService.open(contentCrop, {
      backdrop: "static",
      keyboard: false,
    });
  }

  closeCropper() {
    this.modalCropper.close();
  }

  uploadmedia() {
    this.imageError = "";
    this.videoError = "";
    this.formError = "";
    const filteredUrls = this.event_urls.filter(
      (u: any) => u.url && u.url.trim()
    );
    const hasImages = this.base64Images.length > 0;
    const hasPreImages = this.eventMediaListImage.length > 0;
    const hasVideos = this.previewVideos.length > 0;
    const hasUrls = filteredUrls.length > 0;
    const eventVideos = this.event_videos.length > 0;

    if (!hasImages && !hasVideos && !hasUrls && !hasPreImages && !eventVideos) {
      this.formError =
        "Please upload at least one Image, Video, or URL before saving.";
      return;
    }

    if (hasVideos) {
      const invalidVideos = this.previewVideos.filter(
        (v: any) => !v.thumbnail || v.thumbnail.trim() === ""
      );
      if (invalidVideos.length > 0) {
        this.formError = "Please upload a thumbnail for each uploaded video.";
        return;
      }
    }

    if (hasUrls) {
      for (let i = 0; i < filteredUrls.length; i++) {
        const url = (filteredUrls[i].url || "").trim();
        if (url) {
          const youtubeRegex =
            /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
          if (!youtubeRegex.test(url)) {
            this.formError = `URL${i + 1} is not a valid YouTube link.`;
            return;
          }
        }
        if (!url) {
          this.formError = `Please enter a YouTube URL for the uploaded thumbnail in field ${
            i + 1
          }.`;
          return;
        }
      }
    }

    const payload = {
      event_id: this.event_id,
      event_images: this.base64Images || [],
      event_urls: filteredUrls || [],
      event_videos: this.previewVideos || [],
    };

    this.loadShow();

    this.dataService.eventMediaUpload(payload).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.modalReference.close();
          this.allEvent();
          this.alertService.success("Event media uploaded successfully", true);
        } else if (res["status"] == 500) {
          this.formError = res["mesg"];
          setTimeout(() => {
            this.formError = "";
          }, 5000);
        }
        this.loadHide();
      },
      (error) => {
        this.alertService.error(error);
        this.loadHide();
      }
    );
  }

  fileChangeImage(event: any) {
    this.imageError = "";
    this.videoError = "";

    const files: FileList = event.target.files;
    const date = Date.now();

    if (!files || files.length === 0) return;

    const validExtensions = this.fileType
      .split(",")
      .map((ext) => ext.trim().toLowerCase());

    Array.from(files).forEach((file: File) => {
      const extension = "." + file.name.split(".").pop().toLowerCase();

      const fileKey = `${file.name}_${file.size}_${date}`;
      if (this.selectedFiles.has(fileKey)) return;
      this.selectedFiles.add(fileKey);

      if (!validExtensions.includes(extension)) {
        alert(
          `Invalid file type: ${extension}. Allowed types: ${this.fileType}`
        );
        return;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const base64String: string = e.target.result;
        const tempIndex = this.previewImages.length;

        const fileReport = this.buildFileReport(file, base64String);
        this.dataService.fileUploadCheck(fileReport).subscribe((res: any) => {
          if (res && res["status"] === 200) {
            this.previewImages.push(base64String);
            this.base64Images.push(base64String);
          } else if (res && res["status"] === 422) {
            this.removeOrBlankImage(tempIndex, file.name);
            this.imageError =
              res["errors"][0]["name"] +
              ` exceed the allowed size limit (Limit kb - ${res["errors"][0]["limit_kb"]})`;
          }
        });
      };
      reader.readAsDataURL(file);
    });

    event.target.value = "";
  }

  buildFileReport(currentFile: File, base64String: string): any {
    const files: any[] = [];

    files.push({
      type: "image",
      size: Math.round(currentFile.size / 1024),
      name: currentFile.name,
      extension: currentFile.name.split(".").pop().toLowerCase() || "jpg",
    });

    this.base64Images.forEach((b64: string, index) => {
      if (b64 === base64String) return;
      const tempFile = this.dataURLtoFile(b64, "temp.jpg");
      const name =
        this.extractFileNameFromBase64(b64) || `image_${index + 1}.jpg`;

      files.push({
        type: "image",
        size: Math.round(tempFile.size / 1024),
        name,
        extension: name.split(".").pop().toLowerCase() || "jpg",
      });
    });

    this.previewVideos.forEach((vid: any, index) => {
      const tempFile = this.dataURLtoFile(vid.video, "temp.mp4");
      const name =
        this.extractFileNameFromBase64(vid.video) || `video_${index + 1}.mp4`;

      files.push({
        type: "video",
        size: Math.round(tempFile.size / 1024),
        name,
        extension: name.split(".").pop().toLowerCase() || "mp4",
      });
    });

    return { files };
  }

  private removeOrBlankImage(index: number, fileName: string) {
    if (index >= this.previewImages.length) return;
    this.previewImages.splice(index, 1);
    this.base64Images.splice(index, 1);
  }
}
